import { Close } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Box,
  Card,
  CardContent,
  CardMedia,
  DialogContent,
  Divider,
  IconButton,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import OTPInput from "react-otp-input";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
// import { Rating } from "react-simple-star-rating";
import Rating from "@mui/material/Rating";

import { RootState } from "../../Store";
import { strings } from "../../Store/Localization";
import CustomButton from "../../UiComponent/CustomButton";
import DraggableDialog from "../../UiComponent/DraggableDialog";
import Loader from "../../UiComponent/Loader";
import CustomizedSteppers from "../../UiComponent/OrderStatusStepper";
import Toast from "../../UiComponent/Toast/Toast";
import {
  ExpandedIcon,
  HomeIcon,
  HoverStar,
  PointerIcon,
  StarIcon,
  StarIconGray,
  VerifyIcon,
} from "../../assets/images/FrankIcons";
import noImageFile from "../../assets/images/FrankIcons/noImageAvailable.png";
import apiServices from "../../services/RequestHandler";
import FrankConstants from "../../utils/FrankConstants";
import {
  clearDataFromLocalStorage,
  getDataFromLocalStorage,
} from "../../utils/LocalStore.util";
import {
  defaultLabelColors,
  getStatusColors,
  no_profile_image,
  status_translations,
} from "../../utils/constants";
import {
  currencyFormat,
  handleLocalize,
  numberFormatWithoutCurrency,
} from "../../utils/helper";
import { addDoc, collection } from "firebase/firestore";
import { firestoreDB } from "../../utils/notificationListner";
import noImageTwo from "../../assets/images/FrankIcons/noImageAvailable.png";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}
function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
function DrawerJobDetail(props: any) {
  const { ann_id, onClose, classes } = props;
  const [otp, setOtp] = React.useState("");
  const selector = useSelector((state: RootState) => state);
  const [selectedImage, setSelectedImage] = useState("");
  const param = useParams();
  const navigate = useNavigate();
  const [value, setValue] = React.useState(0);
  const [hover, setHover] = useState(-1);

  const location = useLocation();

  const user = getDataFromLocalStorage("user");
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const [state, setState] = React.useReducer(
    (state: any, newState: any) => ({ ...state, ...newState }),
    {
      showPickupOtpScreen: false,
      loadingLoader: true,
      ratingsCount: 1,
    }
  );

  useEffect(() => {
    handleGetProdInfo(ann_id);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onInputChange = (e: any) => {
    try {
      const { value, name } = e.target;
      if (value[0] === " ") {
        return;
      }

      setState({
        [name]: value,
      });
    } catch (error) {}
  };

  const handleGetProdInfo = async (job_id: any) => {
    try {
      const obj ={ 
        id:Number(job_id ?? param?.id),
        customer_id:Number(user?.id)
      }
      const resp = await apiServices.postFromApi(
        `c2c-shipments/details`,obj,
        ""
      );
      console.log("resp",resp);
      
      const data = resp?.data;
      const steps = [
        {
          status: "Miss En ligne",
          created_at: data?.order_statuses[0]?.created_at
            ? data?.order_statuses[0]?.created_at
            : "",
          active: data?.order_statuses[0]?.created_at ? true : false,
        },
        {
          status: "Acceptée",
          created_at: data?.order_statuses[1]?.created_at
            ? data?.order_statuses[1]?.created_at
            : "",
          active: data?.order_statuses[1]?.created_at ? true : false,
        },
        {
          status: "Payée",
          created_at:
            data?.payment_status === "Paid" ? "2025-03-24T11:39:40.242Z" : "",
          active: data?.payment_status === "Paid" ? true : false,
        },

        {
          status: "Expédiée",
          created_at: data?.order_statuses[2]?.created_at
            ? data?.order_statuses[2]?.created_at
            : "",
          active: data?.order_statuses[2]?.created_at ? true : false,
        },
        {
          status: "Livrée",

          created_at: data?.order_statuses[3]?.created_at
            ? data?.order_statuses[3]?.created_at
            : "",
          active: data?.order_statuses[3]?.created_at ? true : false,
        },
        {
          status: "Laisser un commentaire",

          created_at: data?.feedback ? "2025-12-12" : "",

          active: data?.feedback ? true : false,
        },
        {
          status: "Merci",

          created_at: data?.feedback ? "2025-12-12" : "",

          active: data?.feedback ? true : false,
        },
      ];
      const totalImages = data?.shipment_items?.reduce(
        (acc: any, item: any) => acc + (item?.prod_images?.length || 0),
        0
      );
      setState({
        totalImages,
        job_details: resp?.data,
        steps,
      });

      setSelectedImage(
        resp?.data?.shipment_items[0]?.prod_images?.[0] ?? noImageFile
      );
      if (resp.data?.user_details?.id) {
        const response = await apiServices.getFromApi(
          `c2c/get-user-details/${resp.data?.user_details?.id}`,
          ""
        );

        let avg_rating_ = response.data?.ratings2?.reduce((a: any, b: any) => {
          return a + b.rating;
        }, 0);
        let avg_rating = isNaN(avg_rating_ / response?.data?.ratings2?.length)
          ? 0
          : avg_rating_ / response?.data?.ratings2?.length;

        setState({ announcer_detail: response?.data, avg_rating });
      }

      // handleGetShopInfo(job_details?.shop_id);
      setState({ loadingLoader: false });
    } catch (error) {
      console.log(error);
    }
  };

  const handleAddFeedback = async () => {
    try {
      let obj = [
        {
          order_id: Number(state.job_details?.id),
          rating_from_id: `${state.job_details?.acc_id}`,
          rating_to_id: `${state.job_details?.user_details?.id}`,
          rating: state?.ratingsCount ?? 1,
          feedback: state?.feedback,
        },
      ];

      // console.log(job_details, "job-details");

      // console.log(obj, "object");

      // return;
      let resp = await apiServices.postFromApi(
        "c2c-feedbacks",
        { data: obj },
        ""
      );

      if (resp?.status === 200 || resp?.status === 201) {
        handleGetProdInfo(state.job_details?.id);
        Toast.showSuccess("Notes attribuées avec succès à l'expéditeur");

        setState({
          feedbackDialog: false,
        });
      }
    } catch (error) {}
  };

  const handleComplete = (otpValue: any) => {
    if (otpValue?.length === 4) {
      if (state?.job_details?.ship_status === "Accepted") {
        handlePickOrder(otpValue);
        return;
      }
      if (state?.job_details?.ship_status === "Picked") {
        handleDeliverOrder(otpValue);
        return;
      }
    }
  };
  const handlePickOrder = async (otp: any) => {
    try {
      let obj = {
        ship_id: Number(state?.job_details.id),
        ship_status: "Picked",
        ship_pickup_otp: Number(otp),
      };

      let resp = await apiServices.postFromApi(
        "c2c-shipments/update-status",
        obj,
        ""
      );
      if (resp?.status === 201 || resp?.status === 200) {
        Toast.showSuccess(
          selector.mainApp.lang === "en"
            ? `Your delivery moves on to the next step :package:`
            : "Votre livraison passe à l'étape suivante :package:"
        );
        let new_msg: any = {
          message: `The Pickup OTP validated successfully!`,
          message_status: "sent",
          order_id: `${state?.job_details?.id ?? ""}`,
          is_negotiate: true,
          pickup_otp: true,
          order_details: null,
          sender_id: `${user?.id}`,
          receiver_id: `${state?.job_details?.user_details?.id}`,
          created_at: new Date().toISOString(),
          ship_id: `${state?.job_details?.id}`,
        };
        await addDoc(collection(firestoreDB, `chat_negotiations`), new_msg);

        setState({ showPickupOtpScreen: false });
        handleGetProdInfo(ann_id);
        setOtp("");
        return;
      } else {
        Toast.Error(strings?.pickup_otp_for_transporter ?? resp?.error);
      }
    } catch (error) {}
  };
  const handleDeliverOrder = async (otp: any) => {
    try {
      let obj = {
        ship_id: Number(state?.job_details?.id),
        ship_status: "Deliver",
        ship_deliver_otp: Number(otp),
      };

      let resp = await apiServices.postFromApi(
        "c2c-shipments/update-status",
        obj,
        ""
      );
      if (resp?.status === 201 || resp?.status === 200) {
        Toast.showSuccess(
          selector.mainApp.lang === "en"
            ? `Your delivery moves on to the next step :package:`
            : "Votre livraison passe à l'étape suivante :package:"
        );

        let new_msg: any = {
          message: `Delivery OTP Validated Successfully`,
          message_status: "sent",
          order_id: `${state?.job_details?.id ?? ""}`,
          is_negotiate: true,
          deliver_otp: true,
          order_details: null,
          sender_id: `${user?.id}`,
          receiver_id: `${state?.job_details?.user_details?.id}`,
          created_at: new Date().toISOString(),
          ship_id: `${state?.job_details?.id}`,
        };
        await addDoc(collection(firestoreDB, `chat_negotiations`), new_msg);
        setState({ showPickupOtpScreen: false });
        handleGetProdInfo(ann_id);
        setOtp("");
      } else {
        Toast.Error(
          resp?.data?.error ??
            resp?.error?.error ??
            resp?.data?.isEmail ??
            resp?.data?.isNotEmpty ??
            resp?.message ??
            "Something went wrong. Please wait a short while and try again. If problem persists then contact to support team."
        );
      }
    } catch (error) {
      console.log(error);
    }
  };
  const transSizes = (item: any) => {
    const deliveryType = FrankConstants.packageSize(
      selector.mainApp.lang
    )?.find((a: any) => a.size === item?.cat_name);
    return deliveryType?.size_trans;
  };

  const { job_details } = state;
  const transSizesTwo = (item: any) => {
    const deliveryType = FrankConstants.packageSize(
      selector.mainApp.lang
    )?.find((a: any) => a.size === item?.cat_name);
    return deliveryType?.weight_fr;
  };
  const transSizesName = (item: any) => {
    const deliveryType = FrankConstants.packageSize(
      selector.mainApp.lang
    )?.find((a: any) => a.size === item?.cat_name);
    return deliveryType?.size_trans;
  };

  const [showMore, setShowMore] = useState(false);

  return (
    <div
    //  className="web-screen"
    >
      <Helmet>
        <title>Job Details | Frank</title>
        <meta name="description" content="" />
      </Helmet>
      {state?.loadingLoader ? (
        <Loader loading={state?.loadingLoader} />
      ) : (
        <div style={{ background: "#FFFF", padding: 24 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {job_details?.shipment_items?.length > 1 ? (
              <div>
                <h3
                  style={{
                    color: "#080626",
                    fontFamily: "montserrat-Bold",
                    fontSize: 18,
                    marginLeft: 1,
                    display: "-webkit-box",
                    WebkitLineClamp: 1, // Ensures the text is limited to one line
                    lineClamp: 1, // Fallback for browsers that support it
                    WebkitBoxOrient: "vertical",
                    maxWidth: "100%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    // margin:0
                  }}
                >
                  {job_details?.shipment_items?.length ?? 1} articles :
                  <span
                    style={{
                      color: "#78778A",
                      fontFamily: "montserrat-Regular",
                      fontSize: 12,
                      marginLeft: 1,
                    }}
                  >
                    {" "}
                    {job_details?.shipment_items
                      ?.map((item: any) => item.item_name_fr)
                      .join(", ")}
                  </span>
                </h3>
              </div>
            ) : (
              <h3
                style={{
                  color: "#080626",
                  fontFamily: "montserrat-Bold",
                  fontSize: 18,
                  // margin:0
                }}
              >
                {" "}
                {handleLocalize({
                  en: job_details?.shipment_items?.[0]?.item_name_en?.en,
                  fr: job_details?.shipment_items?.[0]?.item_name_fr?.en,
                }) ??
                  job_details?.shipment_items?.[0]?.prod_name ??
                  ""}
              </h3>
            )}

            <IconButton onClick={onClose}>
              <Close />
            </IconButton>
          </Box>

          <div style={{ display: "flex", gap: 24, padding: "10px 0px" }}>
            <div
              style={{
                borderRadius: "8px",
                padding: "4px 12px",
                fontFamily: "montserrat-SemiBold",
                fontSize: 16,
                background: getStatusColors[job_details?.ship_status]?.bg,
                color: getStatusColors[job_details?.ship_status]?.txt,
                height: "max-content",
              }}
            >
              {handleLocalize(status_translations[job_details?.ship_status])}
            </div>
            <div>
              {" "}
              <p
                style={{
                  margin: 0,
                  color: defaultLabelColors?.main_orange_new,
                  fontSize: 24,
                  fontFamily: "montserrat-Bold",
                }}
              >{`${job_details?.ship_price ?? ""} €`}</p>
            </div>
          </div>

          <div
            id="scroller-image"
            style={{
              display: "flex",
              overflowX: "auto", // Enables horizontal scrolling
              gap: "10px", // Space between images
            }}
            className={classes?.scrollableAreaa}
          >
            {job_details?.shipment_items?.map((item: any, itemIndex: any) =>
              item?.prod_images?.map((image: any, index: any) => (
                <div
                  key={`${itemIndex}-${index}`}
                  style={{
                    flex: "0 0 auto", // Important for horizontal scroll
                    // borderRadius: "16px",
                    padding: "10px 0px",
                    width:
                      state?.totalImages === 1
                        ? "100%"
                        : state?.totalImages === 2
                        ? "49%"
                        : state?.totalImages === 3
                        ? "32%"
                        : "210px",
                  }}
                >
                  <img
                    src={image}
                    alt="image-not-found"
                    onError={(e) => {
                      e.currentTarget.onerror = null; // Prevent infinite loop
                      e.currentTarget.src = noImageTwo; // Replace with your fallback image variable
                    }}
                    style={{
                      width: "100%",
                      height: state?.totalImages <= 1 ? "285px" : "210px",
                      objectFit: "cover",
                      borderRadius: "16px",
                    }}
                  />
                </div>
              ))
            )}
          </div>

          <div className="display-flex" style={{ margin: "20px 0px" }}>
            {job_details?.ship_status === "Accepted" &&
            !job_details?.ship_pickup_otp ? (
              <div
                style={{
                  background: "#fff",
                  borderRadius: "12px",
                  color: "#000",
                  fontSize: "16px",
                  fontFamily: "montserrat-Bold",
                  padding: "10px 20px",
                  textAlign: "center",
                  border: `1px solid ${defaultLabelColors?.main_font_grey}`,
                }}
              >
                En attente du paiement{" "}
              </div>
            ) : null}

            {job_details?.ship_status === "Accepted" &&
            job_details?.ship_pickup_otp ? (
              <>
                {selector?.mainApp?.user?.idenfy_verification === true &&
                selector?.mainApp?.user?.idenfy_verification_status ===
                  "APPROVED" ? (
                  <div
                    className="display-flex"
                    style={{ gap: 10, flexDirection: "column" }}
                  >
                    <p
                      style={{
                        fontFamily: "Raleway-Bold",
                        fontSize: "20px",
                        color: "black",
                        margin: 0,
                        textAlign: "center",
                      }}
                    >
                      {job_details?.ship_status === "Accepted" ? (
                        <span>
                          Veuillez demander à l’expéditeur le code de retrait
                          pour confirmer le ramassage
                        </span>
                      ) : job_details?.ship_status === "Picked" ? (
                        <span>
                          {" "}
                          Code à demander au <br /> destinataire{" "}
                        </span>
                      ) : null}
                    </p>
                    <OTPInput
                      inputStyle={{
                        fontFamily: "Raleway-Extra-Bold",
                        fontSize: "22px",
                        color: "#000",
                        border: "1px solid #C0C0C0",
                        background: "#fff",
                        borderRadius: "10px",
                        padding: "16px",
                      }}
                      inputType="number"
                      value={otp}
                      onChange={(otpValue) => {
                        setOtp(otpValue);
                        // handleComplete(otpValue);
                      }}
                      numInputs={4}
                      renderSeparator={<span style={{ padding: "5px" }}></span>}
                      renderInput={(props) => <input {...props} />}
                    />
                    <div
                      style={{
                        background:
                          otp?.length === 4
                            ? defaultLabelColors?.main_orange_new
                            : "lightgrey",
                        borderRadius: "12px",
                        color: state?.show_stripe ? "#fff" : "#fff",
                        fontSize: "16px",
                        fontFamily: "montserrat-Bold",
                        padding: "12px 20px",
                        textAlign: "center",
                        cursor: "pointer",
                        width: "135px",
                      }}
                      onClick={() => {
                        handleComplete(otp);
                      }}
                    >
                      {
                        // strings?.continue_payment
                        "Confirmer"
                      }
                    </div>
                  </div>
                ) : (
                  <>
                    <div
                      style={{
                        background: "lightgrey",
                        borderRadius: "12px",
                        color: "gray",
                        fontSize: "16px",
                        fontFamily: "Raleway-Bold",
                        padding: 20,
                        textAlign: "center",
                      }}
                    >
                      Récuperer le colis
                      <p style={{ fontSize: "12px" }}>
                        Veuillez vérifier votre compte via votre{" "}
                        <span
                          onClick={() => {
                            clearDataFromLocalStorage("tab_state");
                            navigate("/profile");
                          }}
                          style={{
                            cursor: "pointer",
                            color: defaultLabelColors.main_orange,
                          }}
                        >
                          profil{" "}
                        </span>
                        avant de recevoir une annonce
                      </p>
                    </div>
                  </>
                )}
              </>
            ) : null}
            {job_details?.ship_status === "Picked" ? (
              <div
                id="papa"
                style={{ display: "flex", gap: 10, flexDirection: "column" }}
              >
                <div
                  className="display-flex"
                  style={{ gap: 10, flexDirection: "column" }}
                >
                  <p
                    style={{
                      fontFamily: "montserrat-Bold",
                      fontSize: "12px",
                      color: "#E0E0E0",
                      margin: 0,
                      textAlign: "center",
                    }}
                  >
                    Veuillez demander à l’expéditeur le code de retrait pour
                    confirmer le ramassage
                  </p>
                  <OTPInput
                    inputStyle={{
                      fontFamily: "montserrat-Bold",
                      fontSize: "12px",
                      color: "#E0E0E0",
                      border: "1px solid #E0E0E0",
                      background: "#fff",
                      borderRadius: "10px",
                      padding: "16px",
                    }}
                    inputType="number"
                    value={job_details?.ship_pickup_otp}
                    onChange={(otpValue) => {
                      setOtp(otpValue);
                      // handleComplete(otpValue);
                    }}
                    numInputs={4}
                    renderSeparator={<span style={{ padding: "5px" }}></span>}
                    renderInput={(props) => <input {...props} />}
                  />
                </div>
                <div
                  className="display-flex"
                  style={{ gap: 10, flexDirection: "column" }}
                >
                  <p
                    style={{
                      fontFamily: "Raleway-Bold",
                      fontSize: "20px",
                      color: "black",
                      margin: 0,
                      textAlign: "center",
                    }}
                  >
                    Félicitation votre livraison passe à l’étape suivante !
                    <br></br>
                    Veuillez demander au destinataire le code pour valider la
                    livraison
                  </p>
                  <OTPInput
                    inputStyle={{
                      fontFamily: "Raleway-Extra-Bold",
                      fontSize: "22px",
                      color: "#000",
                      border: "1px solid #C0C0C0",
                      background: "#fff",
                      borderRadius: "10px",
                      padding: "16px",
                    }}
                    inputType="number"
                    value={otp}
                    onChange={(otpValue) => {
                      setOtp(otpValue);
                      // handleComplete(otpValue);
                    }}
                    numInputs={4}
                    renderSeparator={<span style={{ padding: "5px" }}></span>}
                    renderInput={(props) => <input {...props} />}
                  />
                  <div
                    style={{
                      background:
                        otp?.length === 4
                          ? defaultLabelColors?.main_orange_new
                          : "lightgrey",
                      borderRadius: "12px",
                      color: state?.show_stripe ? "#fff" : "#fff",
                      fontSize: "16px",
                      fontFamily: "montserrat-Bold",
                      padding: "12px 20px",
                      textAlign: "center",
                      cursor: "pointer",
                      width: "135px",
                    }}
                    onClick={() => {
                      handleComplete(otp);
                    }}
                  >
                    {
                      // strings?.continue_payment
                      "Confirmer"
                    }
                  </div>
                </div>
              </div>
            ) : null}
            {job_details?.ship_status === "Deliver" ? (
              job_details?.feedback ? null : (
                <div
                  style={{
                    background: defaultLabelColors?.main_orange_new,
                    borderRadius: "12px",
                    color: "#FFF",
                    fontSize: "16px",

                    fontFamily: "montserrat-Bold",
                    padding: "12px 16px",
                    textAlign: "center",
                    cursor: "pointer",
                    width: "251px",
                  }}
                  onClick={() => {
                    setState({ feedbackDialog: true });
                  }}
                >
                  Laisser un commentaire
                </div>
              )
            ) : null}
            {/* end */}
          </div>
          <div style={{ borderBottom: "1px solid #E0E0E0" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              sx={{ width: "100%" }}
              TabIndicatorProps={{
                style: {
                  backgroundColor: defaultLabelColors?.main_orange_new,
                  color: defaultLabelColors?.main_orange_new,
                },
              }}
            >
              <Tab
                label="Détails"
                {...a11yProps(0)}
                sx={{
                  //   width: "50%",
                  //   maxWidth: "50% !important",
                  fontFamily: "montserrat-SemiBold",
                  textTransform: "none", // Disable uppercase
                  color: "#000000",
                  paddingLeft: "0px !important",
                  textAlign: "left !important",
                  minWidth: "0px !important",
                  "&.Mui-selected": {
                    color: defaultLabelColors?.main_orange_new,
                  },
                }}
              />
              <Tab
                label="Suivi"
                {...a11yProps(1)}
                sx={{
                  //   width: "50%",
                  //   maxWidth: "50% !important",
                  display: "flex",
                  minWidth: "0px !important",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  fontFamily: "montserrat-SemiBold",
                  textTransform: "none", // Disable uppercase
                  padding: "12px 10px 12px 1px",
                  color: "#000000",
                  "&.Mui-selected": {
                    color: defaultLabelColors?.main_orange_new,
                  },
                }}
              />
            </Tabs>
          </div>
          <CustomTabPanel value={value} index={0}>
            <div>
              {job_details?.ship_status_level > 1 ? (
                <>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 10,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <p
                        style={{
                          color: "#080626",
                          fontFamily: "montserrat-Regular",
                          fontSize: 14,
                        }}
                      >
                        Détail de l’expéditeur
                      </p>{" "}
                      <p
                        style={{
                          color: "#78778A",
                          fontFamily: "montserrat-Regular",
                          fontSize: 12,
                        }}
                      >
                        {`Membre depuis ${moment(
                          state?.announcer_detail?.created_at
                        ).format("YYYY")}`}
                      </p>
                    </div>
                    <div style={{ display: "flex", gap: 15 }}>
                      <div style={{ position: "relative" }}>
                        <Avatar
                          alt="Remy Sharp"
                          src={
                            state?.announcer_detail?.profile_pic ??
                            no_profile_image
                          }
                          // "https://t4.ftcdn.net/jpg/02/79/66/93/360_F_279669366_Lk12QalYQKMczLEa4ySjhaLtx1M2u7e6.jpg"
                          style={{ width: 60, height: 60 }}
                        />

                        {state?.announcer_detail?.idenfy_verification ===
                          true &&
                        state?.announcer_detail?.idenfy_verification_status ===
                          "APPROVED" ? (
                          <div
                            style={{
                              position: "absolute",
                              bottom: "0%",
                              right: 0,
                            }}
                          >
                            <VerifyIcon />
                          </div>
                        ) : null}
                      </div>

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 10,
                        }}
                      >
                        <p
                          style={{
                            color: "#080626",
                            fontFamily: "montserrat-Bold",
                            fontSize: 18,
                            margin: 0,
                          }}
                        >
                          {`${state?.announcer_detail?.first_name ?? ""} ${
                            state?.announcer_detail?.surname ?? ""
                          }`}
                        </p>
                        <div style={{ display: "flex" }}>
                          <p
                            style={{
                              color: "#080626",
                              fontFamily: "montserrat-Bold",
                              fontSize: 18,
                              margin: 0,
                            }}
                          >
                            {numberFormatWithoutCurrency(state?.avg_rating)}{" "}
                            &nbsp;
                          </p>
                          <span style={{ display: "flex" }}>
                            <svg
                              width="20"
                              height="19"
                              viewBox="0 0 20 19"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9.60404 1.91371C9.64056 1.83993 9.69697 1.77782 9.76692 1.7344C9.83686 1.69098 9.91755 1.66797 9.99987 1.66797C10.0822 1.66797 10.1629 1.69098 10.2328 1.7344C10.3028 1.77782 10.3592 1.83993 10.3957 1.91371L12.3207 5.81288C12.4475 6.06952 12.6347 6.29155 12.8662 6.45992C13.0977 6.6283 13.3666 6.73797 13.6499 6.77955L17.9549 7.40955C18.0364 7.42137 18.1131 7.45577 18.1761 7.50888C18.2391 7.56199 18.2861 7.63167 18.3116 7.71005C18.337 7.78843 18.3401 7.87239 18.3204 7.95241C18.3006 8.03243 18.2589 8.10534 18.1999 8.16288L15.0865 11.1945C14.8812 11.3946 14.7276 11.6416 14.6389 11.9142C14.5502 12.1869 14.5291 12.477 14.5774 12.7595L15.3124 17.0429C15.3268 17.1244 15.318 17.2083 15.287 17.2851C15.2559 17.3619 15.204 17.4284 15.137 17.477C15.07 17.5257 14.9907 17.5545 14.9081 17.5603C14.8255 17.566 14.743 17.5485 14.6699 17.5095L10.8215 15.4862C10.568 15.3531 10.2859 15.2835 9.99946 15.2835C9.71306 15.2835 9.43094 15.3531 9.17737 15.4862L5.32987 17.5095C5.25681 17.5482 5.17437 17.5656 5.09191 17.5598C5.00946 17.5539 4.9303 17.525 4.86345 17.4764C4.7966 17.4278 4.74473 17.3614 4.71375 17.2847C4.68277 17.2081 4.67392 17.1243 4.68821 17.0429L5.42237 12.7604C5.47087 12.4777 5.44986 12.1874 5.36115 11.9146C5.27245 11.6418 5.11871 11.3947 4.91321 11.1945L1.79987 8.16371C1.74037 8.10624 1.6982 8.03321 1.67817 7.95294C1.65815 7.87267 1.66107 7.78839 1.6866 7.70971C1.71214 7.63102 1.75926 7.56108 1.8226 7.50787C1.88594 7.45465 1.96296 7.4203 2.04487 7.40871L6.34904 6.77955C6.63259 6.7383 6.90186 6.62876 7.13369 6.46037C7.36552 6.29198 7.55296 6.06977 7.67987 5.81288L9.60404 1.91371Z"
                                fill="black"
                                stroke="black"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </span>
                        </div>
                      </div>
                    </div>
                    {location?.pathname === "/chat" ? null : (
                      <div
                        style={{
                          background: "#ffff",
                          borderRadius: "12px",
                          color: "#080626",
                          fontSize: "16px",
                          fontFamily: "montserrat-Bold",
                          padding: "12px 20px",
                          textAlign: "center",
                          cursor: "pointer",
                          width: "205px",
                          border: "1px solid #BCBBC4",
                        }}
                        onClick={() => {
                          navigate(`/chat/1/${job_details?.id}`);
                        }}
                      >
                        {"Accéder à la messagerie"}
                      </div>
                    )}
                    <Divider
                      color="#E9E8EB"
                      style={{ marginTop: 20 }}
                      sx={{
                        "&::before, &::after": {
                          color: "#E9E8EB",
                        },
                      }}
                    ></Divider>
                  </div>
                </>
              ) : null}

              <div
                className="card-details"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  // rowGap: 4,
                  marginTop: 20,
                  gap: 15,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-around",
                  }}
                >
                  <div
                    style={{
                      width: "36px",
                      height: "36px",
                      borderRadius: "50%",
                      background: "#FFFFFF",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <HomeIcon height={30} color="#3026F1" />
                  </div>

                  {/* Dashed Line */}
                  <div
                    style={{
                      width: "2px",
                      height: "60px",
                      borderLeft: "2px dashed #BCBBC4",
                      margin: "auto",
                    }}
                  />
                  <div
                    style={{
                      width: "36px",
                      height: "36px",
                      borderRadius: "50%",
                      background: "#FFFFFF",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <PointerIcon height={30} color="#F15A24" />
                  </div>
                </div>
                <div
                  id="address-div"
                  style={{
                    display: "flex",
                    // gap: 15,
                    justifyContent: "space-between",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <div
                    id="yess"
                    style={{
                      display: "flex",
                      // justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 4,
                      }}
                    >
                      <div
                        style={{
                          color: "#0000000",
                          fontSize: 14,
                          fontFamily: "montserrat-Regular",
                          margin: "2px 0px",
                        }}
                      >
                        Adresse de ramassage
                      </div>
                      <div
                        style={{
                          color: "#0000000",
                          fontSize: 16,
                          fontFamily: "montserrat-SemiBold",
                        }}
                      >
                        {`${job_details?.pickup?.address}`}
                        <div
                          style={{
                            fontSize: 12,
                            fontFamily: "montserrat-Regular",
                            color: "#00000",
                            margin: "2px 0px",
                          }}
                        >
                          {`${job_details?.pickup?.additional_info} `}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{ display: "flex", flexDirection: "column", gap: 4 }}
                  >
                    <div
                      style={{
                        color: "#0000000",
                        fontSize: 14,
                        fontFamily: "montserrat-Regular",
                        // margin:"2px 0px"
                      }}
                    >
                      Adresse de livraison
                    </div>
                    <div
                      style={{
                        color: "#0000000",
                        fontSize: 16,
                        fontFamily: "montserrat-SemiBold",
                      }}
                    >
                      {`${job_details?.dropoff?.address ?? "city"} `}
                    </div>
                    <div
                      style={{
                        fontSize: 12,
                        fontFamily: "montserrat-Regular",
                        color: "#00000",
                        // margin:"2px 0px"
                      }}
                    >
                      {`${job_details?.dropoff?.additional_info ?? ""} `}
                    </div>
                  </div>
                </div>
              </div>
              <Divider
                color="#E9E8EB"
                style={{ marginTop: 20 }}
                sx={{
                  "&::before, &::after": {
                    color: "#E9E8EB",
                  },
                }}
              ></Divider>
              <div>
                <div>
                  <h3
                    style={{
                      fontSize: 18,
                      fontFamily: "montserrat-Bold",
                    }}
                  >
                    Destinataire
                  </h3>

                  <p
                    style={{
                      fontSize: 16,
                      fontFamily: "montserrat-SemiBold",
                      margin: 0,
                      color: "#4B4A61",
                    }}
                  >
                    {job_details?.recipient_name ?? ""}
                  </p>
                  <p
                    style={{
                      fontSize: 16,
                      fontFamily: "montserrat-SemiBold",
                      margin: 0,
                      marginTop: 2,

                      color: "#4B4A61",
                    }}
                  >
                    {job_details?.recipient_phone_code}{" "}
                    {job_details?.recipient_phone}
                  </p>
                </div>
              </div>
              <Divider
                color="#E9E8EB"
                style={{ marginTop: 20, marginBottom: 20 }}
                sx={{
                  "&::before, &::after": {
                    color: "#E9E8EB",
                  },
                }}
              ></Divider>

              {job_details?.shipment_items?.length > 1 ? (
                <>
                  {job_details?.shipment_items?.map((i: any) => (
                    <Accordion
                      elevation={0}
                      sx={{
                        border: "none",
                        background: "#FFFF",
                        margin: 0,
                        "&::before": { display: "none" },
                      }}
                      // expanded={state?.expanded_2}
                      // onChange={() => handleExpanded("expanded_2")}
                    >
                      <AccordionSummary
                        style={{ border: "none" }}
                        // expandIcon={<AddIcon />}
                        expandIcon={<ExpandedIcon />} // Dynamic icon change
                        // className="faq-comments"
                        sx={{
                          "&.Mui-expanded h3": {
                            color: defaultLabelColors?.main_orange_new,
                          }, // Change h3 color when expanded
                        }}
                      >
                        <h3
                          style={{
                            fontFamily: "montserrat-Bold",
                            color: "#080626",
                            fontSize: 18,
                            margin: 0,
                            // padding: "20px 0px",
                          }}
                        >
                          {handleLocalize({
                            en: i?.item_name_en,
                            fr: i?.item_name_fr,
                          })}
                        </h3>
                      </AccordionSummary>
                      <AccordionDetails>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 8,
                          }}
                        >
                          <p
                            style={{
                              fontSize: 14,
                              fontFamily: "montserrat-Regular",
                              color: "#4B4A61",
                            }}
                          >
                            Produits & dimension
                          </p>

                          <p
                            style={{
                              fontSize: 16,
                              fontFamily: "montserrat-Bold",
                              margin: 0,
                              color: "#080626",
                            }}
                          >
                            {transSizesName(i)} ·&nbsp;
                            <span
                              style={{
                                fontSize: 16,
                                fontFamily: "montserrat-Regular",
                                margin: 0,
                                color: "#626175",
                              }}
                            >
                              {transSizesTwo(i)}
                            </span>
                          </p>
                          <p
                            style={{
                              fontSize: 16,
                              fontFamily: "montserrat-Bold",
                              margin: 0,
                              color: "#080626",
                            }}
                          >
                            Quantité :&nbsp;
                            <span
                              style={{
                                fontSize: 16,
                                fontFamily: "montserrat-Regular",
                                margin: 0,
                                color: "#626175",
                              }}
                            >
                              {`x ${i?.prod_quantity}`}
                            </span>
                          </p>
                          <p
                            style={{
                              fontSize: 16,
                              fontFamily: "montserrat-Bold",
                              margin: 0,
                              color: "#080626",
                            }}
                          >
                            Dimensions :&nbsp;
                            <span
                              style={{
                                fontSize: 16,
                                fontFamily: "montserrat-Regular",
                                margin: 0,
                                color: "#626175",
                              }}
                            >
                              {i?.prod_length ?? 0} x{""}
                              {i?.prod_height ?? 0} x{""}
                              {i?.prod_width ?? 0}
                            </span>
                          </p>
                          <p
                            style={{
                              fontSize: 16,
                              fontFamily: "montserrat-Bold",
                              margin: 0,
                              color: "#080626",
                            }}
                          >
                            Fragile :&nbsp;
                            <span
                              style={{
                                fontSize: 16,
                                fontFamily: "montserrat-Regular",
                                margin: 0,
                                color: "#626175",
                              }}
                            >
                              {i?.prod_is_fragile ? "Oui" : "Non"}
                            </span>
                          </p>
                          {/* <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 8,
                            }}
                          >
                            <p
                              style={{
                                fontSize: 14,
                                fontFamily: "montserrat-Regular",
                                color: "#4B4A61",
                                // margin:0
                              }}
                            >
                              Informations complémentaires
                            </p>
                            <p
                              style={{
                                fontSize: 14,
                                fontFamily: "montserrat-Regular",
                                color: "#000000",
                                margin: 0,
                              }}
                            >
                              {i?.prod_desc
                                ? i?.prod_desc
                                : "No complémentaires"}
                            </p>
                          </div> */}
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 8,
                            }}
                          >
                            <p
                              style={{
                                fontSize: 14,
                                fontFamily: "montserrat-Regular",
                                color: "#4B4A61",
                              }}
                            >
                              Informations complémentaires
                            </p>

                            <p
                              style={{
                                fontSize: 14,
                                fontFamily: "montserrat-Regular",
                                color: "#000000",
                                margin: 0,
                              }}
                            >
                              {i?.prod_desc
                                ? showMore
                                  ? i?.prod_desc
                                  : i?.prod_desc?.slice(0, 150) +
                                    (i?.prod_desc.length > 150 ? "..." : "")
                                : "No complémentaires"}
                            </p>

                            {i?.prod_desc && i?.prod_desc.length > 150 && (
                              <button
                                onClick={() => setShowMore(!showMore)}
                                style={{
                                  fontSize: 14,
                                  fontFamily: "montserrat-Medium",
                                  color: "#0000000",
                                  background: "none",
                                  border: "none",
                                  cursor: "pointer",
                                  padding: 0,
                                  textAlign: "center",
                                  textDecoration: "underline",
                                }}
                              >
                                {showMore ? "Voir moins" : "Voir plus"}
                              </button>
                            )}
                          </div>
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </>
              ) : (
                <div
                  style={{ display: "flex", flexDirection: "column", gap: 8 }}
                >
                  <p
                    style={{
                      fontSize: 14,
                      fontFamily: "montserrat-Regular",
                      color: "#4B4A61",
                    }}
                  >
                    Produits & dimension
                  </p>

                  <p
                    style={{
                      fontSize: 16,
                      fontFamily: "montserrat-Bold",
                      margin: 0,
                      color: "#080626",
                    }}
                  >
                    {transSizesName(job_details?.shipment_items?.[0])} ·&nbsp;
                    <span
                      style={{
                        fontSize: 16,
                        fontFamily: "montserrat-Regular",
                        margin: 0,
                        color: "#626175",
                      }}
                    >
                      {transSizesTwo(job_details?.shipment_items?.[0])}
                    </span>
                  </p>
                  <p
                    style={{
                      fontSize: 16,
                      fontFamily: "montserrat-Bold",
                      margin: 0,
                      color: "#080626",
                    }}
                  >
                    Quantité :&nbsp;
                    <span
                      style={{
                        fontSize: 16,
                        fontFamily: "montserrat-Regular",
                        margin: 0,
                        color: "#626175",
                      }}
                    >
                      {`x ${job_details?.shipment_items?.[0]?.prod_quantity}`}
                    </span>
                  </p>
                  <p
                    style={{
                      fontSize: 16,
                      fontFamily: "montserrat-Bold",
                      margin: 0,
                      color: "#080626",
                    }}
                  >
                    Dimensions :&nbsp;
                    <span
                      style={{
                        fontSize: 16,
                        fontFamily: "montserrat-Regular",
                        margin: 0,
                        color: "#626175",
                      }}
                    >
                      {job_details?.shipment_items?.[0]?.prod_length ?? 0} x{""}
                      {job_details?.shipment_items?.[0]?.prod_height ?? 0} x{""}
                      {job_details?.shipment_items?.[0]?.prod_width ?? 0}
                    </span>
                  </p>
                  <p
                    style={{
                      fontSize: 16,
                      fontFamily: "montserrat-Bold",
                      margin: 0,
                      color: "#080626",
                    }}
                  >
                    Fragile :&nbsp;
                    <span
                      style={{
                        fontSize: 16,
                        fontFamily: "montserrat-Regular",
                        margin: 0,
                        color: "#626175",
                      }}
                    >
                      {job_details?.shipment_items?.[0]?.prod_is_fragile
                        ? "Oui"
                        : "Non"}
                    </span>
                  </p>
                </div>
              )}
              <Divider
                color="#E9E8EB"
                style={{ marginTop: 20 }}
                sx={{
                  "&::before, &::after": {
                    color: "#E9E8EB",
                  },
                }}
              ></Divider>

              {job_details?.shipment_items?.length === 1 && (
                <>
                  {/* <div
                    style={{ display: "flex", flexDirection: "column", gap: 8 }}
                  >
                    <p
                      style={{
                        fontSize: 14,
                        fontFamily: "montserrat-Regular",
                        color: "#4B4A61",
                        // margin:0
                      }}
                    >
                      Informations complémentaires
                    </p>
                    <p
                      style={{
                        fontSize: 14,
                        fontFamily: "montserrat-Regular",
                        color: "#000000",
                        margin: 0,
                      }}
                    >
                      {job_details?.shipment_items[0]?.prod_desc
                        ? job_details?.shipment_items[0]?.prod_desc
                        : "No complémentaires"}
                    </p>
                  </div> */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 8,
                    }}
                  >
                    <p
                      style={{
                        fontSize: 14,
                        fontFamily: "montserrat-Regular",
                        color: "#4B4A61",
                      }}
                    >
                      Informations complémentaires
                    </p>

                    <p
                      style={{
                        fontSize: 14,
                        fontFamily: "montserrat-Regular",
                        color: "#000000",
                        margin: 0,
                      }}
                    >
                      {job_details?.shipment_items[0]?.prod_desc
                        ? showMore
                          ? job_details?.shipment_items[0]?.prod_desc
                          : job_details?.shipment_items[0]?.prod_desc?.slice(
                              0,
                              150
                            ) +
                            (job_details?.shipment_items[0]?.prod_desc.length >
                            150
                              ? "..."
                              : "")
                        : "No complémentaires"}
                    </p>

                    {job_details?.shipment_items[0]?.prod_desc &&
                      job_details?.shipment_items[0]?.prod_desc.length >
                        150 && (
                        <button
                          onClick={() => setShowMore(!showMore)}
                          style={{
                            fontSize: 14,
                            fontFamily: "montserrat-Medium",
                            color: "#0000000",
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            padding: 0,
                            textAlign: "center",
                            textDecoration: "underline",
                          }}
                        >
                          {showMore ? "Voir moins" : "Voir plus"}
                        </button>
                      )}
                  </div>
                  <Divider
                    color="#E9E8EB"
                    style={{ marginTop: 20 }}
                    sx={{
                      "&::before, &::after": {
                        color: "#E9E8EB",
                      },
                    }}
                  ></Divider>
                </>
              )}

              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <p
                  style={{
                    fontSize: 14,
                    fontFamily: "montserrat-Regular",
                    color: "#4B4A61",
                    margin: 0,
                    marginTop: 10,
                  }}
                >
                  Votre envoi
                </p>
                <div
                  style={{
                    fontSize: 14,
                    fontFamily: "montserrat-Regular",
                    color: "#000000",
                    margin: 0,
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <p style={{ margin: 0 }}>Tarif proposé</p>{" "}
                  <p style={{ margin: 0 }}>
                    {" "}
                    {job_details?.promo ? (
                      <span style={{ marginRight: "10px", color: "red" }}>
                        {" "}
                        <s>
                          {job_details?.agree_ship_price
                            ? job_details?.agree_ship_price
                            : job_details?.ship_price}
                        </s>
                      </span>
                    ) : null}
                    {job_details?.promo
                      ? currencyFormat(
                          Number(
                            (job_details?.agree_ship_price ||
                              job_details?.ship_price) -
                              (job_details?.promo?.discount_amount || 0)
                          )
                        )
                      : currencyFormat(
                          Number(
                            job_details?.agree_ship_price ??
                              job_details?.ship_price ??
                              0
                          )
                        )}
                    €
                  </p>
                </div>
                <div
                  style={{
                    fontSize: 14,
                    fontFamily: "montserrat-Regular",
                    color: "#000000",
                    margin: 0,
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  {/* {console.log("job_details",job_details) as any} */}
                  
                  <p style={{ margin: 0 }}> Frais de service</p>{" "}
                  <p style={{ margin: 0 }}>
                    {/* {job_details?.promo?.is_platform_charges ? (
                      <span style={{ marginRight: "10px", color: "red" }}>
                        {" "}
                        <s>{job_details?.service_charges}</s>
                      </span>
                    ) : null} */}
                    {/* {job_details?.promo?.is_platform_charges
                      ? "0.00"
                      : currencyFormat(
                          Number(
                            (job_details?.order_amount_detail
                              ?.commission_amount ?? 0) +
                              (job_details?.order_amount_detail
                                ?.commission_tax_amount ?? 0)
                          )
                        )}{" "} */}
                        {currencyFormat(job_details?.commission_details?.commission_amount + job_details?.commission_details?.commission_tax_amount)}
                    €
                  </p>
                </div>
                <div
                  style={{
                    fontSize: 18,
                    fontFamily: "montserrat-Bold",
                    color: defaultLabelColors?.main_orange_new,
                    margin: 0,
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <p style={{ margin: 0 }}>Total </p>{" "}
                  <p style={{ margin: 0 }}>
                    {" "}
                    {/* {job_details?.promo
                      ? currencyFormat(
                          Number(
                            Number(
                              job_details?.promo?.actual_order_amount -
                                job_details?.promo?.discount_amount
                            )
                          ) +
                            Number(
                              job_details?.promo?.is_platform_charges
                                ? 0
                                : job_details?.service_charges
                            )
                        )
                      : 
                      currencyFormat(
                          Number(
                            Number(
                              job_details?.agree_ship_price ??
                                job_details?.ship_price ??
                                0
                            ) -
                              Number(
                                (job_details?.order_amount_detail
                                  ?.commission_amount ?? 0) +
                                  (job_details?.order_amount_detail
                                    ?.commission_tax_amount ?? 0)
                              )
                          )
                        )}{" "} */}
                        
                        {currencyFormat(Number(
                              job_details?.agree_ship_price ??
                                job_details?.ship_price ??
                                0
                            ) -
                              Number(job_details?.commission_details?.commission_amount + job_details?.commission_details?.commission_tax_amount))
                                
                            }
                          
                        
                    €
                  </p>
                </div>
              </div>

              {/* {job_details?.ship_status_level === 1 ||
            job_details?.ship_status === "Placed" ? (
              <>
                <Divider
                  color="#E9E8EB"
                  style={{ marginTop: 20 }}
                  sx={{
                    "&::before, &::after": {
                      color: "#E9E8EB",
                    },
                  }}
                ></Divider>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 16,
                  }}
                >
                  <div></div>
                  <div>
                    <p
                      style={{
                        margin: 0,
                        textAlign: "right",
                        color: "#F00",
                        fontSize: 16,
                        fontFamily: "montserrat-Bold",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setState({ openConfirmDialog: true });
                      }}
                    >
                      Supprimer l’annonce
                    </p>
                  </div>
                </div>
              </>
            ) : null} */}
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <CustomizedSteppers order_array={state?.steps} />
          </CustomTabPanel>
        </div>
      )}

      <DraggableDialog
        maxWidth={"md"}
        Width={660}
        open={state?.feedbackDialog}
        handleClose={() => {
          setState({
            feedbackDialog: false,
          });
        }}
        dialog_title={"Laisser un commentaire"}
        dialogBody={
          <DialogContent style={{}}>
            <>
              <div
                style={{
                  padding: 10,
                  borderBottom: "1px solid #E9E8EB",
                  gap: 10,
                }}
              >
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <div
                    style={{
                      // width: "20%",
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      gap: 20,
                    }}
                  >
                    <div style={{ position: "relative" }}>
                      <Avatar
                        alt="Remy Sharp"
                        src={
                          job_details?.user_details?.profile_pic ??
                          no_profile_image
                        }
                        // "https://t4.ftcdn.net/jpg/02/79/66/93/360_F_279669366_Lk12QalYQKMczLEa4ySjhaLtx1M2u7e6.jpg"
                        style={{ width: 60, height: 60 }}
                      />
                      <div
                        style={{
                          position: "absolute",
                          bottom: "0%",
                          right: 0,
                        }}
                      >
                        <VerifyIcon />
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        gap: 10,
                        flexDirection: "column",
                      }}
                    >
                      <div
                        style={{
                          fontFamily: "montserrat-Bold",
                          color: "#080626",

                          fontSize: "18px",
                          fontWeight: 600,
                        }}
                      >
                        {job_details?.user_details?.cus_name ?? "Customer Name"}
                      </div>
                      <div style={{ display: "flex" }}>
                        <p
                          style={{
                            color: "#080626",
                            fontFamily: "montserrat-Bold",
                            fontSize: 22,
                            margin: 0,
                          }}
                        >
                          {currencyFormat(
                            job_details?.user_details?.cus_ratings?.toFixed(1)
                          )}{" "}
                          &nbsp;
                        </p>
                        <span style={{ display: "flex" }}>
                          <svg
                            width="20"
                            height="19"
                            viewBox="0 0 20 19"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9.60404 1.91371C9.64056 1.83993 9.69697 1.77782 9.76692 1.7344C9.83686 1.69098 9.91755 1.66797 9.99987 1.66797C10.0822 1.66797 10.1629 1.69098 10.2328 1.7344C10.3028 1.77782 10.3592 1.83993 10.3957 1.91371L12.3207 5.81288C12.4475 6.06952 12.6347 6.29155 12.8662 6.45992C13.0977 6.6283 13.3666 6.73797 13.6499 6.77955L17.9549 7.40955C18.0364 7.42137 18.1131 7.45577 18.1761 7.50888C18.2391 7.56199 18.2861 7.63167 18.3116 7.71005C18.337 7.78843 18.3401 7.87239 18.3204 7.95241C18.3006 8.03243 18.2589 8.10534 18.1999 8.16288L15.0865 11.1945C14.8812 11.3946 14.7276 11.6416 14.6389 11.9142C14.5502 12.1869 14.5291 12.477 14.5774 12.7595L15.3124 17.0429C15.3268 17.1244 15.318 17.2083 15.287 17.2851C15.2559 17.3619 15.204 17.4284 15.137 17.477C15.07 17.5257 14.9907 17.5545 14.9081 17.5603C14.8255 17.566 14.743 17.5485 14.6699 17.5095L10.8215 15.4862C10.568 15.3531 10.2859 15.2835 9.99946 15.2835C9.71306 15.2835 9.43094 15.3531 9.17737 15.4862L5.32987 17.5095C5.25681 17.5482 5.17437 17.5656 5.09191 17.5598C5.00946 17.5539 4.9303 17.525 4.86345 17.4764C4.7966 17.4278 4.74473 17.3614 4.71375 17.2847C4.68277 17.2081 4.67392 17.1243 4.68821 17.0429L5.42237 12.7604C5.47087 12.4777 5.44986 12.1874 5.36115 11.9146C5.27245 11.6418 5.11871 11.3947 4.91321 11.1945L1.79987 8.16371C1.74037 8.10624 1.6982 8.03321 1.67817 7.95294C1.65815 7.87267 1.66107 7.78839 1.6866 7.70971C1.71214 7.63102 1.75926 7.56108 1.8226 7.50787C1.88594 7.45465 1.96296 7.4203 2.04487 7.40871L6.34904 6.77955C6.63259 6.7383 6.90186 6.62876 7.13369 6.46037C7.36552 6.29198 7.55296 6.06977 7.67987 5.81288L9.60404 1.91371Z"
                              fill="black"
                              stroke="black"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div style={{ display: "flex", justifyContent: "center" }}>
                    {/* <Rating
                      initialValue={state?.ratingsCount}
                      allowHover={true}
                      size={40}
                      allowFraction
                      onClick={(value: any) => {
                        setState({ ratingsCount: value });
                      }}
                      fillIcon={<StarIcon />}
                      emptyIcon={<StarIconGray />}
                    /> */}
                    <Rating
                      name="three-icons"
                      value={state?.ratingsCount}
                      max={5}
                      precision={1}
                      onChange={(event, newValue) => {
                        setState({ ratingsCount: newValue });
                      }}
                      onChangeActive={(event, newHover) => {
                        setHover(newHover);
                      }}
                      IconContainerComponent={({ value: index, ...props }) => {
                        if (hover !== -1) {
                          // When hovering
                          if (index < hover) {
                            // Stars before hovered one
                            return (
                              <span {...props}>
                                <StarIcon />
                              </span>
                            );
                          } else if (index === hover) {
                            // The hovered star
                            return (
                              <span {...props}>
                                <HoverStar />
                              </span>
                            );
                          } else {
                            // Stars after hovered one
                            return (
                              <span {...props}>
                                <StarIconGray />
                              </span>
                            );
                          }
                        } else {
                          // When not hovering — use selected value logic
                          if (state?.ratingsCount >= index) {
                            return (
                              <span {...props}>
                                <StarIcon />
                              </span>
                            );
                          } else {
                            return (
                              <span {...props}>
                                <StarIconGray />
                              </span>
                            );
                          }
                        }
                      }}
                      sx={{ fontSize: 40, gap: "5px" }}
                    />
                  </div>
                </div>
              </div>
              <div style={{ padding: 0 }}>
                <p
                  style={{
                    // fontFamily: "Raleway-Semi-Bold",
                    // color: "#000",
                    marginBottom: 1,
                    fontFamily: "montserrat-Bold",
                    color: "#080626",

                    fontSize: "16px",
                  }}
                >
                  Écrivez votre commentaire
                </p>
                <div
                  id="yessor"
                  style={{ display: "flex", gap: 30, flexDirection: "column" }}
                >
                  {/* <InputField
                    placeHolder={"Exemple : Parfait ! Rapide et efficace"}
                    isMultiLine={true}
                    input_rows={3}
                    input_type={"text"}
                    input_value={state.feedback ?? ""}
                    onchange={onInputChange}
                    input_name={"feedback"}
                    input_style={{
                      background: "#F4F3F6",
                      width: "100%",
                      borderRadius: "16px",
                      border: "none",
                      fontSize: "16px",
                      margin: "0px",
                      marginBottom: 10,
                    }}
                  /> */}
                  <TextField
                    placeholder="Exemple : Parfait ! Rapide et efficace"
                    variant="outlined"
                    fullWidth
                    type="text"
                    value={state.feedback ?? ""}
                    name="feedback"
                    onChange={onInputChange}
                    maxRows={3}
                    minRows={3}
                    multiline
                    InputProps={{
                      sx: {
                        backgroundColor: "#F4F3F6",
                        fontFamily: "montserrat-Regular",
                        border: "none",

                        "& fieldset": {
                          border: "none",
                        },
                      },
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "16px", // Optional: rounded corners
                      },
                    }}
                  />
                  <CustomButton
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      color: "#fff",
                      fontFamily: "Raleway-Variable",
                      background: state?.feedback ? "#ee6931" : "lightgrey",
                      border: "none",
                      borderRadius: "12px",
                      padding: "10px 40px 10px 40px",
                      width: "100%",
                    }}
                    disable={state?.feedback ? false : true}
                    onClick={handleAddFeedback}
                    value={"Envoyer"}
                  />
                </div>
              </div>
            </>
          </DialogContent>
        }
      />

      <DraggableDialog
        maxWidth={"md"}
        open={state?.itemDetailsDialog}
        handleClose={() => {
          setState({ itemDetailsDialog: false });
        }}
        dialog_title={""}
        dialogBody={
          <DialogContent style={{}} dividers>
            <div>
              <Card
                elevation={0}
                sx={{
                  borderRadius: "32px",
                  overflow: "hidden",
                  border: "1px solid #E0E0E0",
                }}
              >
                <Box
                  position="relative"
                  sx={{ borderRadius: "32px 32px 0px 0px" }}
                >
                  <div style={{ height: "380px" }} className="display-flex">
                    <CardMedia
                      component="img"
                      image={
                        selectedImage ?? "https://via.placeholder.com/300x200"
                      }
                      alt="Product Image"
                      sx={{
                        objectFit: "contain",
                        width: "98%",
                        height: "360px",
                        borderRadius: "32px 32px 0px 0px",
                      }}
                    />
                  </div>
                </Box>

                <CardContent>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginBottom: "30px",
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <Typography
                        variant="h6"
                        color="#3B3A3A"
                        sx={{
                          fontFamily: "Raleway-Bold",
                        }}
                      >
                        {handleLocalize({
                          en: state?.itemDetails?.item_name_en,
                          fr: state?.itemDetails?.item_name_fr,
                        }) ??
                          state?.itemDetails?.prod_name ??
                          ""}
                        <span> </span>
                      </Typography>
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      gap: 5,
                    }}
                  >
                    {state?.itemDetails?.prod_images?.map((item: any) => {
                      return (
                        <div
                          className="display-flex"
                          style={{
                            height: "116px",
                            width: "116px",
                            cursor: "pointer",
                            borderRadius: "12px",
                            border: `2px solid ${
                              selectedImage === item
                                ? defaultLabelColors.main_orange
                                : "grey"
                            } `,
                          }}
                          onClick={() => {
                            setSelectedImage(item);
                          }}
                        >
                          <img
                            src={item}
                            alt="prod-img"
                            style={{
                              objectFit: "contain",
                              height: "110px",
                            }}
                          />
                        </div>
                      );
                    })}
                  </div>
                </CardContent>
              </Card>
            </div>
          </DialogContent>
        }
      />
    </div>
  );
}

export default DrawerJobDetail;
